import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Component({
  selector: 'app-image-cropper-modal',
  templateUrl: './image-cropper.component.html',
  styleUrls: ['./image-cropper.component.scss']
})
export class ImageCropperModalComponent {

  @Input() imageBase64!: string;

  @Output() cropped = new EventEmitter<File>();
  @Output() cancel = new EventEmitter<void>();

  aspectRatio = 1 / 1;
  croppedImage: string = '';
  imageLoaded = false;
  readonly NaN = NaN;

  ngOnInit(){
    console.log(this.imageBase64)
  }

  onImageLoaded() {
    this.imageLoaded = true;
  }

  onCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64!;
  }

  confirmCrop() {

    const file = this.base64ToFile(this.croppedImage, 'cropped.jpeg');
    console.log('imagen cargada correctamente:', file)
    this.cropped.emit(file);
  }

  base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    const u8arr = new Uint8Array(bstr.length);
    for (let i = 0; i < bstr.length; i++) u8arr[i] = bstr.charCodeAt(i);
    return new File([u8arr], filename, { type: mime });
  }

  get shouldMaintainAspectRatio(): boolean {
    return !isNaN(this.aspectRatio);
  }
}
